import axios, { AxiosRequestConfig } from "axios";

export interface ShoppingCartApiConfig {
  basePath: string;
  baseOptions: AxiosRequestConfig;
}

export interface CartCountInterface {
    storeId: number;
}

class ShoppingCartApi {
  private basePath: string;
  private baseOptions: AxiosRequestConfig;

  constructor(config: ShoppingCartApiConfig) {
    this.basePath = config?.basePath ?? "";
    this.baseOptions = config.baseOptions;
  }

  async getCartCount<T>(params: CartCountInterface): Promise<T | any> {
    const options: AxiosRequestConfig = {
      ...this.baseOptions,
      method: "GET"
    };
    const url = `${this.basePath}/itxrest/1/order/store/${params?.storeId}/cart/count`;

    try {
      const response = await axios(url, options);
      return await response.data;
    } catch (error) {
      throw new Error("Failed to fetch cart count.");
    }
  }

}

export default ShoppingCartApi;
